import React, { ChangeEvent, CSSProperties, FunctionComponent, useRef } from 'react';
import { NumberFormatPropsBase } from 'react-number-format';
import { Container, Label, Input, InputBox, Prefix } from './NumberInput.style';
import ValidationError from './ValidationError';

interface Props {
  prefix?: string;
  label?: JSX.Element | string;
  value: string;
  className?: string;
  onValueChange?: (value: string) => void;
  placeholder?: string;
  containerStyle?: CSSProperties;
  testID?: string;
  name: string;
  error?: string | false;
  onFocus?: () => void;
  decimalScale?: NumberFormatPropsBase['decimalScale'];
}

const NumberInput: FunctionComponent<Props> = (props) => {
  const ref = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    ref.current?.focus();
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (props.onValueChange) {
      props.onValueChange(e.target.value);
    }
  };

  return (
    <Container className={props.className} style={props.containerStyle}>
      {props.label && <Label htmlFor={props.name}>{props.label}</Label>}

      <InputBox onClick={handleClick} error={props.error}>
        <Prefix>{props.prefix}</Prefix>

        <Input
          getInputRef={ref}
          id={props.name}
          name={props.name}
          thousandSeparator
          onChange={handleChange}
          value={props.value}
          data-testid={props.testID}
          placeholder={props.placeholder}
          onFocus={props.onFocus}
          decimalScale={props.decimalScale}
        />
      </InputBox>

      <ValidationError error={props.error} />
    </Container>
  );
};

export default NumberInput;
